import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/features/auth/store/auth.store";

/**
 * Shows the app in the language saved on the user's account.
 *
 * The language switcher saves the choice to the account, but i18n reads its
 * start language from this browser (localStorage, then the browser language).
 * Without this, a user who chose Hindi sees English on a new device. Runs
 * when a user loads or logs in. With no user, or a user who never picked a
 * language (languagePreference is null), the browser's language stays.
 */
export function useSavedLanguage(): void {
	const saved = useAuthStore((s) => s.user?.languagePreference);
	const { i18n } = useTranslation();

	useEffect(() => {
		if (saved && i18n.resolvedLanguage !== saved) {
			void i18n.changeLanguage(saved);
		}
	}, [saved, i18n]);
}
